__turbopack_context__.v({
  "container": "tidfVG_container",
  "mainRecommendedCardWrapper": "tidfVG_mainRecommendedCardWrapper",
  "mainRecommendedCardWrapperInfo": "tidfVG_mainRecommendedCardWrapperInfo",
  "mainRecommendedCardWrapper_category": "tidfVG_mainRecommendedCardWrapper_category",
  "mainRecommendedCardWrapper_date": "tidfVG_mainRecommendedCardWrapper_date",
  "mainRecommendedCardWrapper_imgWarpper": "tidfVG_mainRecommendedCardWrapper_imgWarpper",
  "mainRecommendedCardWrapper_title": "tidfVG_mainRecommendedCardWrapper_title",
  "subRecomendedCards": "tidfVG_subRecomendedCards",
  "subRecomendedCardsInfo": "tidfVG_subRecomendedCardsInfo",
  "subRecomendedCardsWrapper": "tidfVG_subRecomendedCardsWrapper",
  "subRecomendedCards_category": "tidfVG_subRecomendedCards_category",
  "subRecomendedCards_imgWarpper": "tidfVG_subRecomendedCards_imgWarpper",
  "subRecomendedCards_title": "tidfVG_subRecomendedCards_title",
  "titleWrapper": "tidfVG_titleWrapper",
});
